import styled from 'styled-components';

const PrintHidden = styled.span`
  @media print {
    display: none;
    width: auto;
    border: 0;
    margin: 0;
    padding: 0;
    float: none;
    overflow: visible;
  }
`;
export default PrintHidden;
